/* @flow */
import { ageGroup, gender, type AgeGroup as AgeGroupType, type Gender as GenderType } from './rules/types';

export const Gender = gender;
export const AllGenders: GenderType[] = (Object.values(Gender): any);

export const AgeGroup = ageGroup;
export const AllAgeGroups: AgeGroupType[] = (Object.values(AgeGroup): any);
